import React, {ReactElement} from 'react'
import {Flex, useMultiStyleConfig, FlexProps} from '@chakra-ui/react'
import {Icon} from '_uiComponents'

interface ChipsProps {
    children: string | ReactElement
    ariaLabelText?: string
    onClick?: () => void
}

/**
 * @name Chips
 *
 * @component
 *
 * @description
 * Renders a flexible container with an icon and children elements.
 *
 * @param {ChipsProps} props - The properties for the Chips component.
 * @param {React.ReactNode} props.children - The content to be displayed inside the Chips component.
 * @param {string} [props.ariaLabelText] - Aria label for accessibility purposes.
 * @param {() => void} [props.onClick] - The function to be called when the Chips component is clicked.
 *
 * @returns {JSX.Element} The rendered `Chips` component.
 */
const Chips: React.FC<ChipsProps> = ({children, ariaLabelText, onClick}) => {
    const styles = useMultiStyleConfig('Chips') as Record<string, FlexProps>

    return (
        <Flex {...styles.wrapper} role="button" onClick={onClick} onKeyDown={(e) => e.key === 'Enter' && onClick?.()} tabIndex={0} aria-label={ariaLabelText}>
            {children}
            <Icon name="IconCloseLight" size="md" />
        </Flex>
    )
}

export {Chips}
